import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 34, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line headline reveal.
// The animation is driven by the (unclipped) parent via variants – children inside
// overflow:hidden masks must never own their own viewport observer.
export const RevealLines = ({ lines, className = "", delay = 0, as = "h1", onLoad = false }) => {
  const Tag = motion[as] || motion.h1;

  const parent = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.11, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "112%", opacity: 0 },
    visible: { y: "0%", opacity: 1, transition: { duration: 1, ease: EASE } },
  };

  const trigger = onLoad
    ? { animate: "visible" }
    : { whileInView: "visible", viewport: { once: true, amount: 0.15 } };

  return (
    <Tag variants={parent} initial="hidden" {...trigger} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span variants={child} className="block">
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const GrowLine = ({ className = "", vertical = true, delay = 0 }) => (
  <motion.div
    initial={vertical ? { scaleY: 0 } : { scaleX: 0 }}
    whileInView={vertical ? { scaleY: 1 } : { scaleX: 1 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 1.4, delay, ease: EASE }}
    style={{ originY: 0, originX: 0 }}
    className={className}
  />
);
